export default __webpack_public_path__ + "static/media/Maduro1.3056e6f2.png";